import { useEffect, useState } from "react";
import { Notification } from "react-bulma-components";
import { useLocation } from "react-router-dom";


const Active = () => {

    const [msg, setMsg] = useState('Sprawdzam kod aktywacyjny...');

    const search = useLocation().search;
    const code = new URLSearchParams(search).get('code');

    useEffect(() => {

        var responseOk = false;

        var formData = new FormData();
        formData.append('activation_code', code);

        fetch('https://studiotworzenia.pl/active.php', {
            crossDomain:true,
            method: 'POST',
            headers: {'Cache-Control': 'no-store'},
            body: formData,
        })
        .then((response) => {
            responseOk = response.ok;
            return response.json();
        })
        .then((result) => {
            if(responseOk){
                setMsg(<Notification color="success">Twoje konto zostało aktywowane! Twój wynik będzie wliczony do rankingu.</Notification>);
            }
            else{
                setMsg(<Notification color="warning">{result.message}</Notification>);   
            }
        });
    }, [code]); 

        return(
            <>{msg}</>
            
        );

}

export default Active;